{
  "wallboard": {
    "instances_count": "沒有執行個體 | {count} 個執行個體 | {count} 個執行個體",
    "label": "資訊看板"
  }
}
